import BaseModel from './BaseModel';

class CsInformationModal extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setDetailsData(data)
  }

  setDetailsData = (data) => {
    this.zone = data.zone;
    this.circle = data.circle;
    this.city = data.city;
    this.address = data.address;
    this.pincode = data.pincode;
    this.charging_zone = data.charging_zone;
    this.firm_name = data.firm_name;
    this.current_bin_version = data.current_bin_version;
    this.bin_version_last_updated_at = data.bin_version_last_updated_at;
    this.current_android_version = data.current_android_version;
    this.android_version_last_updated_at = data.android_version_last_updated_at;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.device_id = data.device_id;
    this.per_swap_rate = data.per_swap_rate;
    this.assigned_at_ist = data.assigned_at_ist;
    this.cp_id = data.cp_id;
    this.cs_created_at_ist = data.cs_created_at_ist;
    this.fg_number = data.fg_number;
    this.sloc = data.sloc;
  }
}

export default CsInformationModal;
